(function() {
  const swiperInstances = new Map();

  function initSlider(slider) {
    const config = JSON.parse(slider.dataset.swiperConfig);
    const swiperEl = slider.querySelector('.swiper');
    
    if (!swiperEl) return;

    // Destroy existing instance if any
    if (swiperInstances.has(slider)) {
      swiperInstances.get(slider).destroy(true, true);
      swiperInstances.delete(slider);
    }

    const nextEl = slider.querySelector('.ctr-energy-ingredients__nav-next');
    const prevEl = slider.querySelector('.ctr-energy-ingredients__nav-prev');
    const paginationEl = slider.querySelector('.ctr-energy-ingredients__pagination');
    const showPagination = slider.closest('.ctr-energy-ingredients--show-pagination') && paginationEl;
    const baseGap = Number(config.slideGap) || 0;
    // Matches the fluid CSS (and ctr-energy-testimonials): gap scales proportionally above 1440px
    const getGap = function() {
      if (window.innerWidth <= 1440) return baseGap;
      return Math.round(baseGap * window.innerWidth / 1440 * 10) / 10;
    };
    const slideGap = getGap();

    const swiperOptions = {
      slidesPerView: config.slidesPerViewAuto ? 'auto' : config.slidesPerViewMobile,
      spaceBetween: slideGap,
      loop: config.loop,
      breakpoints: {
        768: {
          slidesPerView: config.slidesPerViewAuto ? 'auto' : config.slidesPerView
        }
      },
      on: {
        resize: function(sw) {
          const gap = getGap();
          if (sw.params.spaceBetween !== gap) {
            sw.params.spaceBetween = gap;
            sw.update();
          }
        }
      }
    };

    if (showPagination) {
      swiperOptions.pagination = {
        el: paginationEl,
        clickable: true
      };
    }

    if (nextEl && prevEl) {
      swiperOptions.navigation = {
        nextEl: nextEl,
        prevEl: prevEl
      };
    }

    if (config.autoplay) {
      swiperOptions.autoplay = {
        delay: config.autoplaySpeed,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      };
    }

    const swiper = new Swiper(swiperEl, swiperOptions);
    swiperInstances.set(slider, swiper);
    
    return swiper;
  }

  function initAllSliders() {
    document.querySelectorAll('.ctr-energy-ingredients__slider[data-swiper-config]').forEach(function(slider) {
      initSlider(slider);
    });
  }

  function destroySlider(slider) {
    if (swiperInstances.has(slider)) {
      swiperInstances.get(slider).destroy(true, true);
      swiperInstances.delete(slider);
    }
  }

  // ---------------------------------------------------------------------------
  // Category tabs (opt-in: section setting show_tabs). Liquid renders the active
  // tab's slides in the swiper wrapper and the rest in a hidden store next to the
  // slider. Switching moves the slides and rebuilds the slider from slide 1, so
  // arrows, pagination, loop and autoplay all start from a clean state.
  // ---------------------------------------------------------------------------
  const TAB_SELECTOR = '.ctr-energy-ingredients--tabs [role="tab"][data-ei-tab]';

  function showTabSlides(root, tabId) {
    const slider = root.querySelector('.ctr-energy-ingredients__slider[data-swiper-config]');
    const wrapper = slider && slider.querySelector('.swiper-wrapper');
    const store = root.querySelector('.ctr-energy-ingredients__tab-store');
    if (!wrapper || !store) return;

    const slides = Array.from(root.querySelectorAll('.ctr-energy-ingredients__slide[data-ei-tab]'));
    // destroy(…, true) strips inline styles, which also hold each card's colour/gradient vars
    const styles = slides.map(function(slide) { return slide.getAttribute('style'); });
    if (swiperInstances.has(slider)) {
      swiperInstances.get(slider).destroy(true, true);
      swiperInstances.delete(slider);
    }
    slides.forEach(function(slide, i) {
      if (styles[i] !== null) slide.setAttribute('style', styles[i]);
    });

    slides
      .sort(function(a, b) { return Number(a.dataset.eiIndex) - Number(b.dataset.eiIndex); })
      .forEach(function(slide) {
        (slide.dataset.eiTab === tabId ? wrapper : store).appendChild(slide);
      });

    initSlider(slider);
  }

  function selectTab(tab, focus) {
    const tablist = tab.closest('[role="tablist"]');
    const root = tab.closest('.ctr-energy-ingredients--tabs');
    if (!tablist || !root) return;
    if (focus) tab.focus();
    if (tab.getAttribute('aria-selected') === 'true') return;

    tablist.querySelectorAll('[role="tab"]').forEach(function(t) {
      const active = t === tab;
      t.setAttribute('aria-selected', active ? 'true' : 'false');
      t.setAttribute('tabindex', active ? '0' : '-1');
    });
    const panel = root.querySelector('.ctr-energy-ingredients__slider[role="tabpanel"]');
    if (panel) panel.setAttribute('aria-labelledby', tab.id);

    showTabSlides(root, tab.dataset.eiTab);
  }

  document.addEventListener('click', function(event) {
    const tab = event.target.closest(TAB_SELECTOR);
    if (tab) selectTab(tab, false);
  });

  document.addEventListener('keydown', function(event) {
    const tab = event.target.closest && event.target.closest(TAB_SELECTOR);
    if (!tab) return;
    const tabs = Array.from(tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]'));
    const i = tabs.indexOf(tab);
    let next = null;
    if (event.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
    else if (event.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
    else if (event.key === 'Home') next = tabs[0];
    else if (event.key === 'End') next = tabs[tabs.length - 1];
    if (!next) return;
    event.preventDefault();
    selectTab(next, true);
  });

  // Theme editor: selecting an ingredient from another tab switches to that tab first
  function revealTabSlide(target) {
    const slide = target.closest && target.closest('.ctr-energy-ingredients__slide[data-ei-tab]');
    const root = slide && slide.closest('.ctr-energy-ingredients--tabs');
    if (!root) return;
    const tab = root.querySelector('[role="tab"][data-ei-tab="' + slide.dataset.eiTab + '"]');
    if (tab) selectTab(tab, false);
  }

  // Smooth-scroll header CTA to on-page anchors, offset for the sticky header
  document.addEventListener('click', function(event) {
    const link = event.target.closest('.ctr-energy-ingredients [data-ctr-ei-scroll]');
    if (!link) return;
    const hash = link.getAttribute('href').split('#')[1];
    const target = hash && document.getElementById(hash);
    if (!target) return;
    event.preventDefault();
    const top = target.getBoundingClientRect().top + window.scrollY - 100;
    window.scrollTo({ top: top, behavior: 'smooth' });
  });

  // Initialize on DOM ready
  document.addEventListener('DOMContentLoaded', initAllSliders);

  // Shopify Theme Editor Events
  document.addEventListener('shopify:section:load', function(event) {
    const slider = event.target.querySelector('.ctr-energy-ingredients__slider[data-swiper-config]');
    if (slider) {
      initSlider(slider);
    }
  });

  document.addEventListener('shopify:section:unload', function(event) {
    const slider = event.target.querySelector('.ctr-energy-ingredients__slider[data-swiper-config]');
    if (slider) {
      destroySlider(slider);
    }
  });

  document.addEventListener('shopify:section:select', function(event) {
    const slider = event.target.querySelector('.ctr-energy-ingredients__slider[data-swiper-config]');
    if (slider && swiperInstances.has(slider)) {
      const swiper = swiperInstances.get(slider);
      if (swiper.autoplay && swiper.autoplay.running) {
        swiper.autoplay.stop();
      }
    }
  });

  document.addEventListener('shopify:section:deselect', function(event) {
    const slider = event.target.querySelector('.ctr-energy-ingredients__slider[data-swiper-config]');
    if (slider && swiperInstances.has(slider)) {
      const swiper = swiperInstances.get(slider);
      const config = JSON.parse(slider.dataset.swiperConfig);
      if (config.autoplay && swiper.autoplay) {
        swiper.autoplay.start();
      }
    }
  });

  document.addEventListener('shopify:block:select', function(event) {
    revealTabSlide(event.target);
    const slider = event.target.closest('.ctr-energy-ingredients__slider[data-swiper-config]');
    if (slider && swiperInstances.has(slider)) {
      const swiper = swiperInstances.get(slider);
      const slide = event.target.closest('.swiper-slide');
      
      if (slide) {
        const slideIndex = Array.from(slider.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)')).indexOf(slide);
        if (slideIndex !== -1) {
          if (swiper.params.loop) {
            swiper.slideToLoop(slideIndex);
          } else {
            swiper.slideTo(slideIndex);
          }
        }
      }
      
      if (swiper.autoplay && swiper.autoplay.running) {
        swiper.autoplay.stop();
      }
    }
  });

  document.addEventListener('shopify:block:deselect', function(event) {
    const slider = event.target.closest('.ctr-energy-ingredients__slider[data-swiper-config]');
    if (slider && swiperInstances.has(slider)) {
      const swiper = swiperInstances.get(slider);
      const config = JSON.parse(slider.dataset.swiperConfig);
      if (config.autoplay && swiper.autoplay) {
        swiper.autoplay.start();
      }
    }
  });
})();
